import React from "react";
import CloseMenu from "../svg/close-menu";
import Button from "../button";
import IconEmailBlue from "../svg/emailBlue";
import IconPhoneVioletBlue from "../svg/phoneVioletBlue";
import Link from "next/link";
import { usePathname } from "next/navigation";
import IconFacebookBlue from "../svg/facebookBlue";
import IconInstagramBlue from "../svg/instagramBlue";
import IconYoutubeBlue from "../svg/youtubeBlue";
import {getStrapiURL} from "../../../helper/image-helper";

interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
    global: {
        siteEmail: string;
        sitePhone: string;
        instagram: string;
        facebook: string;
        youtube: string;
        siteLogo: {
            url: string;
        };
    }; 
    content: {
        headerSocialTitle: string;
    }
    menu: Array<{
        name: string;
        url: string;
    }>;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, global, content, menu }) => {
    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    return (
        <div
            className={`w-full max-w-[576px] h-[100vh] fixed top-0 bg-menu-gradient p-[16px] z-30 
            transition-all duration-500 ease-in-out 
            ${isOpen ? 'left-0' : 'left-[-100%]'}`}
        >
            <div className="flex items-center">
                <div className="flex mr-1" onClick={onClose}>
                    <CloseMenu />
                </div>
                <div className="">
                    <Link href="/">
                        <img src={getStrapiURL(global.siteLogo.url)} alt="komfortflytt.se" className="h-[40px] max-[1200px]:h-[32px]" />
                    </Link>
                </div>
            </div>
            <div className="ml-auto flex items-center gap-4 
                    w-full 
                    mt-[10px] 
                    pt-[10px] 
                    border-dotted 
                    border-gray-200 
                    border-t-2
                    justify-between
                    "
            >
                <Button text={global.sitePhone} notuppercase="yes" mobileFull="yes" href={`tel:${global.sitePhone}`} icon={<IconPhoneVioletBlue />} type="third" />
                <Button text={global.siteEmail} notuppercase="yes" icon={<IconEmailBlue />} href={`mailto:${global.siteEmail}`} type="third" />
            </div>
            <ul className="space-y-[10px] mt-[12px]">
                {menu.map((item, index) => {
                    const isActive = pathname === item.url || (isEn && pathname === `/en${item.url}`);
                    return (
                        <li key={index} className='text-[18px] text-violet-500 font-bold pb-[10px]' onClick={onClose}>
                            <Link href={isEn ? `/en${item.url}` : item.url}>
                                {item.name}
                            </Link>
                        </li>
                    );
                })}
            </ul>
            <div className="text-center mt-[24px]">
                <p className="text-[14px] uppercase text-violet-500 mb-[12px]">{content.headerSocialTitle}</p>
                <div className="flex gap-[16px] justify-center">
                    <a href={global.facebook} target="_blank">
                        <IconFacebookBlue />
                    </a>
                    <a href={global.instagram} target="_blank">
                        <IconInstagramBlue />
                    </a>
                    <a href={global.youtube} target="_blank">
                        <IconYoutubeBlue />
                    </a>
                </div>
            </div>
        </div>
    );
};


export default MobileMenu;
